import { UpdateUnitNameLaravelResponse } from '../models/update-unit-name.model';

import { UpdateUnitNameResponse } from '../models/update-unit-name.model';

export function adaptFromLaravelResponseUpdateUnitName(
  response: UpdateUnitNameLaravelResponse
): UpdateUnitNameResponse {
  return {
    success: response.success,
    message: response.messages,
    data: response.data,
  };
}
